import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { darken, lighten } from '@mui/material/styles';

import appLogo from "../../../../images/website-images/logos/app-logo.png";

import MoneyBackGuaranteeImage from "../../../../images/website-images/money-back-guarantee.png"
import SecuredImage from "../../../../images/website-images/secured.png"
import CancelAnyTimeImage from "../../../../images/website-images/cancel-any-time.png"
import {
  Button,
  Box,
  Typography
} from "@mui/material";

import { getDodoSubscriptionDetails, completeSuccessfulDodoPaymentsSubscription } from "../../../../common/FunctionCalls";

import { useNavigate, Link } from 'react-router-dom';

import {db} from '../../../../firebaseConfig';

import { collection, query, where, doc, getDoc,getDocs, updateDoc, serverTimestamp } from "firebase/firestore";

import { getAuth, onAuthStateChanged } from "firebase/auth";


export default function CheckoutSuccess() {

  const [paymentSucceeded, setPaymentSucceeded] = useState(true);

  const [params] = useSearchParams();

  console.log("Inside CheckoutSuccess");

  const subscriptionId = params.get("subscription_id");
  const status = params.get("status");
  const accountNumber = params.get("accountNumber");

  console.log("subscriptionId-v2:"+subscriptionId);

  const navigate = useNavigate();
 
  console.log("After navigate");

 
useEffect(() => {
  console.log("Checkout successful. SubscriptionId ID:", subscriptionId);

  
  const fetchSessionDetails = async () => {
    const auth = getAuth();

    onAuthStateChanged(auth, async (user) => {
      if (!user) {
        console.log("User is not signed in yet.");
        return;
      }

      try {
        if (subscriptionId) {

          if (status ==="active")
          {
            const subscription = await getDodoSubscriptionDetails(subscriptionId, auth);
            console.log("subscription:", subscription);

            if (subscription) {
              const customerId = subscription.customerId;
              console.log("subscriptionId:", subscriptionId);
              console.log("customerId:", customerId);

              const completedResults =
                await completeSuccessfulDodoPaymentsSubscription(
                  accountNumber,
                  customerId,
                  subscriptionId,
                  auth
                );

              localStorage.setItem("testMode", "false");

              console.log(
                "Updated records with subscription info:",
                JSON.stringify(completedResults)
              );

              setPaymentSucceeded(true);
            }
          } else
          {
             //Tell them there was a problem processing the payment to try again, then send them to accountinfo
             setPaymentSucceeded(false);
          }

        }
      } catch (error) {
        console.error("Error fetching session details:", error);
      }
    });
  };


  if (subscriptionId) {
    fetchSessionDetails();
  }

}, [subscriptionId]);


console.log("At The End subscriptionId-v2:"+subscriptionId);


  return (
<div style={{ 
  minHeight: '100vh', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center', 
  justifyContent: 'start', 
  backgroundColor: '#f9f9f9', 
  paddingTop: '0px' 
}}>

<Box
  mt={3}
  sx={{
    width: '400px',
    marginXXX: 'auto',
    border: '1px solid #ddd',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    padding: '24px',
    backgroundColor: '#ffffff',
    minHeight: '420px',

    zIndex: 1,
    position: 'relative',

  }}
>

 {paymentSucceeded && 
  <div>
      <Box textAlign="center" pb={1}>

          <img
              src={appLogo}
              alt="App Logo"
              style={{ height: 85, cursor: "pointer" }}
              onClick={() => navigate("/")}
          />
            
          <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
          Welcome aboard!
          </Typography>
      </Box>


      <Box textAlign="left" pb={1}>
        <Typography variant="body2" sx={{ fontSize: '16px', paddingBottom:'0px', paddingTop:'16px' }}>
        
        <p>Thank you for subscribing — we're thrilled to have you with us! </p>

        <p>You’ve just unlocked access to powerful tools designed to make your workflows simpler, stay organized and help you grow.</p>

        <p>Get ready for faster results, smarter insights, and seamless collaboration.</p>

        <p>Let’s make great things happen.</p>

        </Typography>
      </Box>

      <Box textAlign="center" pb={1} sx={{paddingTop:'25px', paddingBottom:'15px'}}>
          <Button
            variant="contained"
            onClick={() => navigate('/app')}
            sx={{
              backgroundColor: lighten('#26332D', 0.1),
              '&:hover': {
                backgroundColor: darken('#26332D', 0.1),
              },
              width:'100%',
              height:'40px'
            }}
          >
            Take me to the application
          </Button>
      </Box>
  </div>
}

 {!paymentSucceeded && 
    <div>
      <Box textAlign="center" pb={1}>

          <img
              src={appLogo}
              alt="App Logo"
              style={{ height: 85, cursor: "pointer" }}
              onClick={() => navigate("/")}
          />
            
          <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
          Payment Failed
          </Typography>
      </Box>


      <Box textAlign="left" pb={1}>
        <Typography variant="body2" sx={{ fontSize: '16px', paddingBottom:'0px', paddingTop:'16px' }}>
        
        <p>We are sorry to inform you that your payment failed.</p>

        <p>Your credit card has not been charged.</p>

        <p>Click the button below to try again.</p>

        <p>We apologize for the inconvenience.</p>

        </Typography>
      </Box>

      <Box textAlign="center" pb={1} sx={{paddingTop:'25px', paddingBottom:'15px'}}>
          <Button
            variant="contained"
            onClick={() => navigate('/pricing')}
            sx={{
              backgroundColor: lighten('#26332D', 0.1),
              '&:hover': {
                backgroundColor: darken('#26332D', 0.1),
              },
              width:'100%',
              height:'40px'
            }}
          >
            Try Subscribing Again
          </Button>
      </Box>
  </div>
 }


</Box>

          {/* Footer Links - Full width below grid */}
          <Box
            sx={{
              gridColumn: "1 / -1", // Span both columns
              display: "flex",
              gap: 2,
              mt: 4,
            }}
          >
            <Link to="/" variant="body2">
              Home
            </Link>

            <Link to="/terms-of-service"  target="_blank" variant="body2">
            Terms of Service
            </Link>
          </Box>



{/* Background Triangle Content*/}
  <Box
    sx={{
      position: "fixed",     // Stick to screen corner
      bottom: 0,             // Align to bottom
      right: 0,              // Align to right
      zIndex: 99,
      pointerEvents: "none", // Allows clicks to pass through
      p: 2,                  // Optional padding
      display: { xs: "none", md: "block" } 
    }}
  > 
      <img src={MoneyBackGuaranteeImage} style={{height:'100px', paddingRight:'30px'}}/>

      <img src={CancelAnyTimeImage} style={{height:'100px', paddingRight:'30px'}}/>

      <img src={SecuredImage} style={{height:'100px'}}/>
      
  </Box>
  

{/* Bottom triangle */}
<Box
  sx={{
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: 0,
    height: 0,
    borderLeft: '100vw solid transparent',
    borderBottom: '460px solid #26332D',
    display: { xs: "none", md: "block" },
    zIndex: 0,
    pointerEvents: 'none', // So it doesn't block clicks
  }}
/>

</div> 
  );
}
